// src/modules/Audit/CreateAudit.js

import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import BackButton from '../../components/BackButton'; // Adjust the import path as necessary

const CreateAudit = () => {
  const navigate = useNavigate();
  const [auditData, setAuditData] = useState({
    branch: '',
    date: '',
    time: '',
    teamMembers: '',
  });

  const handleChange = (e) => {
    setAuditData({ ...auditData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    // to send this data to an API when setup is complete
    console.log('New audit data:', auditData);
    // this is mock audit details page
    navigate(`/audit/1`);
  };

  return (
    <div className="bg-gray-100 min-h-screen p-8">
      <BackButton />
      <h1 className="text-3xl font-bold mb-6">Create New Audit</h1>
      <div className="bg-white rounded-lg shadow-lg p-6">
        <form onSubmit={handleSubmit} className="max-w-md">
          <div className="mb-4">
            <label className="block text-gray-700 text-sm font-bold mb-2" htmlFor="branch">
              Branch
            </label>
            <input
              type="text"
              id="branch"
              name="branch"
              value={auditData.branch}
              onChange={handleChange}
              className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
              required
            />
          </div>
          <div className="mb-4">
            <label className="block text-gray-700 text-sm font-bold mb-2" htmlFor="date">
              Date
            </label>
            <input
              type="date"
              id="date"
              name="date"
              value={auditData.date}
              onChange={handleChange}
              className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
              required
            />
          </div>
          <div className="mb-4">
            <label className="block text-gray-700 text-sm font-bold mb-2" htmlFor="time">
              Time
            </label>
            <input
              type="time"
              id="time"
              name="time"
              value={auditData.time}
              onChange={handleChange}
              className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
              required
            />
          </div>
          <div className="mb-6">
            <label className="block text-gray-700 text-sm font-bold mb-2" htmlFor="teamMembers">
              Team Members
            </label>
            <input
              type="text"
              id="teamMembers"
              name="teamMembers"
              value={auditData.teamMembers}
              onChange={handleChange}
              className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
              required
            />
          </div>
          <div className="flex items-center justify-between">
            <button
              type="submit"
              className="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline"
            >
              Start Audit
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default CreateAudit;